import $ from "jquery";
import {Core} from "./core.js";
import * as Sentry from "@sentry/browser";

import './active-script.js'
import './marketo.js'

if ( Core.isProd() ) {
  Sentry.init({
    dsn: "https://64df0dbf25066eb3228b2d11f715f8c0@o4510024069742592.ingest.de.sentry.io/4510069268611152",
    integrations: [Sentry.browserTracingIntegration()],

    // Ignore some errors from 3rd party libs or not interesting
    // (old browsers, private browsing, blocked scripts by user...)
    ignoreErrors: [
      "Failed to read the 'localStorage'",
      "reading 'setItem'",
      "Failed to fetch",
      "Load failed",
      "Non-Error promise rejection"
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.1,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["bim.cegid.com"],

    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: false,
  });
}

import {initSelector} from './selector'
import {HashScroll} from './hash-scroll'
import {initFlexible} from './flexibles'
import {MenuPrimary} from './menu-primary'
import {Modal} from './modal'
import {Search} from './search'
import {Slider} from './slider'
import {Tabs} from './tabs'
import {Sticky} from './sticky'
import {Tracking} from './tracking'
import {TableContent} from './table-content'
import {BackToTop} from "./back-to-top"
import {ScrollDown} from "./scroll-down"
import {Link} from './link'
import {ListEnhancer} from './list'
import {Chatbot} from "./chatbot";
import {Iterable} from "./iterable";
import {Zendesk} from "./zendesk";
import {BannerTop} from "./banner-top.js";
import Animations from "./animations.js";
import LazyloadIOSFix from "./lazyload-polyfill-ios.js";

// Set jQuery fallback
if ( !window?.jQuery && $ ) {
  window.jQuery = $;
}

new Tabs(true)
new Modal()
new Search()
new Slider()
new Sticky()
new HashScroll()
new Tracking()
new MenuPrimary()
new TableContent()
new BackToTop()
new ScrollDown()
new Link()
new ListEnhancer()
new Chatbot()
$(new Iterable());
new Zendesk()
new BannerTop()
new LazyloadIOSFix();

initFlexible()
initSelector()
Core.imgToSvg();
window.addEventListener('load', Core.imgToSvg);

const scriptsController = {
  Animations
};
window.cgd = window?.cgd || {};
window.cgd.scriptsInstances = window.cgd?.scriptsInstances || {};
window.cgd.scriptsInstances = Object.assign(scriptsController, window.cgd.scriptsInstances);
